import React from 'react';
import '../assets/styles/Services.css';
import fertroEmblem from '../assets/images/fertro_icon.png';

const Services = () => {
  const services = [
    {
      title: 'Process Engineering',
      items: [
        'Interim resource support',
        'Technical reports',
        'Process development',
        'Troubleshooting',
        'Process evaluation studies',
      ]
    },
    {
      title: 'Software Engineering',
      description: 'Custom software solutions, system integration, and digital transformation for engineering environments.'
    },
    {
      title: 'Project Management',
      description: 'Efficient project planning, scheduling, and management services to ensure successful delivery.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-title text-center">
          <h2>Our Services</h2>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-header">
                <img src={fertroEmblem} alt="Fertro emblem" className="service-icon" />
                <h3>{service.title.split(' ').map((word, i, arr) =>
                  i < arr.length - 1 ? <React.Fragment key={i}>{word}<br /></React.Fragment> : word
                )}</h3>
              </div>
              {service.items
                ? <ul className="service-list">{service.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
                : <p>{service.description}</p>
              }
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
